import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import visit from "./visit.module";
import job from "./job.module";
import request from "./request.module";
import common from "./common.module";
import customer from "./customer.module";
import quotation from "./quotation.module";
import line_item from "./line.item.module";
import delivery from "./delivery.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    request,
    common,
    visit,
    customer,
    line_item,
    quotation,
    job,
    delivery,
  },
});
